import { sessionStorageService, StorageKeys } from '@ibk/shared-utils';
const DB_NAME = 'DeviceMappingV2';
const STORE_NAME = 'devices';
const getConnectionIndexedDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, 1);
        request.onerror = event => {
            reject(new Error('Error opening database: ' + event.target.error));
        };
        request.onsuccess = event => {
            resolve(event.target.result);
        };
        request.onupgradeneeded = event => {
            const db = event.target.result;
            db.createObjectStore(STORE_NAME, { keyPath: 'personId' });
        };
    });
};
export async function saveDeviceRecord(personId, deviceId, validated) {
    return new Promise((resolve, reject) => {
        getConnectionIndexedDB()
            .then((db) => {
            const transaction = db.transaction([STORE_NAME], 'readwrite');
            const objectStore = transaction.objectStore(STORE_NAME);
            const request = objectStore.put({ personId, deviceId, validated });
            request.onerror = event => reject(new Error('Error storing device: ' + event.target.error));
            request.onsuccess = () => resolve();
        })
            .catch(reject);
    });
}
export async function getDeviceRecordByPersonId(personId) {
    return new Promise((resolve, reject) => {
        getConnectionIndexedDB()
            .then((db) => {
            const transaction = db.transaction([STORE_NAME], 'readonly');
            const objectStore = transaction.objectStore(STORE_NAME);
            const request = objectStore.get(personId);
            request.onerror = event => reject(new Error('Error retrieving device: ' + event.target.error));
            request.onsuccess = event => {
                const result = event.target.result;
                resolve(result || null);
            };
        })
            .catch(reject);
    });
}
export async function deleteDeviceRecordByPersonId(personId) {
    return new Promise((resolve, reject) => {
        getConnectionIndexedDB()
            .then((db) => {
            const transaction = db.transaction([STORE_NAME], 'readwrite');
            const objectStore = transaction.objectStore(STORE_NAME);
            const request = objectStore.delete(personId);
            request.onerror = event => reject(new Error('Error deleting device: ' + event.target.error));
            request.onsuccess = () => resolve();
        })
            .catch(reject);
    });
}
export function getDeviceIdFromSession() {
    const deviceId = sessionStorageService.getItemSync(StorageKeys.DeviceId);
    return deviceId ? deviceId.replaceAll('"', '') : null;
}
export function setDeviceIdInSession(deviceId) {
    sessionStorageService.setItemSync(StorageKeys.DeviceId, deviceId);
}
export function setDeviceValidatedInSession(validated) {
    sessionStorageService.setItemSync(StorageKeys.DeviceValidated, `${validated}`);
}
export function isDeviceValidatedInSession() {
    const validated = sessionStorageService.getItemSync(StorageKeys.DeviceValidated);
    return validated === 'true';
}
export async function getRegisteredDevice(personId) {
    try {
        return await getDeviceRecordByPersonId(personId);
    }
    catch (error) {
        console.error('Error getting registered device:', error);
        return null;
    }
}
export async function saveRegisteredDevice(personId, deviceId, validated) {
    try {
        await saveDeviceRecord(personId, deviceId, validated);
        setDeviceIdInSession(deviceId);
        setDeviceValidatedInSession(validated);
    }
    catch (error) {
        console.error('Error saving registered device:', error);
        throw error;
    }
}
export async function deleteRegisteredDevice(personId) {
    try {
        await deleteDeviceRecordByPersonId(personId);
    }
    catch (error) {
        console.error('Error deleting registered device:', error);
        throw error;
    }
}
export function clearDeviceDataFromSession() {
    sessionStorageService.removeItem(StorageKeys.DeviceId);
    sessionStorageService.removeItem(StorageKeys.DeviceValidated);
}
export function getDeviceInfo() {
    return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        screenResolution: `${screen.width}x${screen.height}`,
        hardwareConcurrency: navigator.hardwareConcurrency,
        deviceMemory: 'unknown',
        timezone: new Date().getTimezoneOffset(),
        cookieEnabled: navigator.cookieEnabled,
        online: navigator.onLine,
        deviceId: getDeviceIdFromSession(),
        isValidated: isDeviceValidatedInSession(),
    };
}
export function getOrCreateDeviceId() {
    let deviceId = getDeviceIdFromSession();
    if (!deviceId) {
        deviceId = crypto.randomUUID();
        setDeviceIdInSession(deviceId);
    }
    return deviceId;
}
